
/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'restart': {
    width: 10.8,
    height: 12.5,
    viewBox: '0 0 10.8 12.5',
    data: '<path pid="0" d="M10.3 6.5c-.3 0-.5.2-.5.5 0 2.5-2 4.5-4.4 4.5C3 11.4 1 9.5 1 7c0-2.4 1.9-4.3 4.2-4.5v1.3l1.7-.9 1.7-1L6.9 1 5.2 0v1.5C2.3 1.7 0 4.1 0 7c0 3 2.4 5.4 5.4 5.5 3 0 5.4-2.5 5.4-5.5 0-.3-.2-.5-.5-.5z" _fill="#8390a0"/>'
  }
})
